(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vrmaker", [], factory);
	else if(typeof exports === 'object')
		exports["vrmaker"] = factory();
	else
		root["vrmaker"] = factory();
})(window, function() {
return 